export default "__VITE_ASSET__0JKHCwmx__"